import { render, staticRenderFns } from "./WordListImport.vue?vue&type=template&id=500f0266"
import script from "./WordListImport.vue?vue&type=script&lang=js"
export * from "./WordListImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports